/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_Site_WaistInputs */

const en_us2_body_measures_site_waist = /** @type {(inputs: Body_Measures_Site_WaistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waist`)
};

const pt_br2_body_measures_site_waist = /** @type {(inputs: Body_Measures_Site_WaistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cintura`)
};

const es_419_body_measures_site_waist = /** @type {(inputs: Body_Measures_Site_WaistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cintura`)
};

const pt_pt2_body_measures_site_waist = /** @type {(inputs: Body_Measures_Site_WaistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cintura`)
};

const fr_fr2_body_measures_site_waist = /** @type {(inputs: Body_Measures_Site_WaistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille`)
};

const de_de2_body_measures_site_waist = /** @type {(inputs: Body_Measures_Site_WaistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille`)
};

const it_it2_body_measures_site_waist = /** @type {(inputs: Body_Measures_Site_WaistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vita`)
};

/**
* | output |
* | --- |
* | "Waist" |
*
* @param {Body_Measures_Site_WaistInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_site_waist = /** @type {((inputs?: Body_Measures_Site_WaistInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Site_WaistInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_site_waist(inputs)
	if (locale === "es-419") return es_419_body_measures_site_waist(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_site_waist(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_site_waist(inputs)
	if (locale === "de-DE") return de_de2_body_measures_site_waist(inputs)
	if (locale === "it-IT") return it_it2_body_measures_site_waist(inputs)
	return en_us2_body_measures_site_waist(inputs)
});
export { body_measures_site_waist as "body-measures.site_waist" }